var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isAnonymous)?_c('loading-layer',{attrs:{"value":_vm.authorizationProgress,"info":_vm.authorizationInfo}}):_vm._e(),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }